/* Veluna — comportamento da loja. Sem dependências. */
(function () {
  'use strict';

  var cfg = window.veluna || {};

  function money(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    var parts = value.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return 'R$ ' + parts.join(',');
  }

  function on(root, event, selector, handler) {
    root.addEventListener(event, function (e) {
      var target = e.target.closest(selector);
      if (target && root.contains(target)) handler(e, target);
    });
  }

  /* ------------------------------------------------------------ gavetas */

  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';

    /* dois quadros para o navegador pintar o estado fechado antes de animar:
       sem isso o painel aparece de uma vez, sem deslizar */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        var focusable = drawer.querySelector('.drawer__close');
        if (focusable) focusable.focus();
      });
    });
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    window.setTimeout(function () {
      if (!drawer.classList.contains('is-open')) drawer.setAttribute('hidden', '');
    }, 280);
  }

  on(document, 'click', '[data-drawer-open]', function (e, el) {
    e.preventDefault();
    openDrawer(document.getElementById(el.getAttribute('data-drawer-open')));
  });

  on(document, 'click', '[data-drawer-close], .drawer__overlay', function (e, el) {
    e.preventDefault();
    closeDrawer(el.closest('.drawer'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.drawer.is-open');
    if (open) closeDrawer(open);
    var panel = document.querySelector('.nav-item__panel:not([hidden])');
    if (panel) {
      panel.setAttribute('hidden', '');
      var toggle = panel.parentElement.querySelector('.nav-item__toggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }
  });

  /* ------------------------------------------------------- menu suspenso */

  function closeMenus(except) {
    document.querySelectorAll('.nav-item__panel').forEach(function (p) {
      if (p === except) return;
      p.setAttribute('hidden', '');
      var t = p.parentElement.querySelector('.nav-item__toggle');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  /* abre só no clique */
  on(document, 'click', '.nav-item__toggle', function (e, el) {
    e.preventDefault();
    var panel = el.parentElement.querySelector('.nav-item__panel');
    if (!panel) return;

    var isOpen = !panel.hasAttribute('hidden');
    closeMenus();

    if (!isOpen) {
      panel.removeAttribute('hidden');
      el.setAttribute('aria-expanded', 'true');
    }
  });

  /* fecha quando o mouse sai do item.
     Delegado no documento para sobreviver ao recarregamento de seções
     no editor de temas, onde listeners presos ao elemento se perderiam. */
  document.addEventListener(
    'mouseover',
    function (e) {
      var panel = document.querySelector('.nav-item__panel:not([hidden])');
      if (!panel) return;

      var item = panel.parentElement;
      if (item.contains(e.target)) return;

      /* se o foco está dentro, quem manda é o teclado: mantém aberto */
      if (item.contains(document.activeElement)) return;

      closeMenus();
    },
    { passive: true }
  );

  /* fecha ao clicar fora */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.nav-item')) return;
    closeMenus();
  });

  /* fecha ao sair pelo teclado */
  document.addEventListener('focusin', function (e) {
    if (e.target.closest('.nav-item')) return;
    closeMenus();
  });

  /* ---------------------------------------------------------------- abas */

  on(document, 'click', '[role="tab"]', function (e, tab) {
    e.preventDefault();
    var list = tab.closest('[role="tablist"]');
    if (!list) return;
    var wrapper = list.parentElement;

    list.querySelectorAll('[role="tab"]').forEach(function (t) {
      t.setAttribute('aria-selected', String(t === tab));
    });

    var id = tab.getAttribute('aria-controls');
    wrapper.querySelectorAll('[role="tabpanel"]').forEach(function (panel) {
      if (panel.id === id) panel.removeAttribute('hidden');
      else panel.setAttribute('hidden', '');
    });
  });

  /* --------------------------------------------- barra de avisos */

  document.querySelectorAll('[data-rotate]').forEach(function (rotator) {
    var messages = rotator.querySelectorAll('.announce__msg');
    if (messages.length < 2) return;

    var index = 0;
    var delay = parseInt(rotator.getAttribute('data-rotate'), 10) || 5000;
    var timer = null;

    function girar() {
      messages[index].hidden = true;
      index = (index + 1) % messages.length;
      messages[index].hidden = false;
    }

    function ligar() {
      if (!timer) timer = setInterval(girar, delay);
    }

    function desligar() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    /* aba escondida nao precisa girar aviso: poupa CPU e bateria */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) desligar();
      else ligar();
    });

    ligar();
  });

  /* copiar cupom */
  on(document, 'click', '[data-copy]', function (e, btn) {
    e.preventDefault();
    var code = btn.getAttribute('data-copy');
    var original = btn.textContent;

    function done() {
      btn.textContent = '✓';
      window.setTimeout(function () {
        btn.textContent = original;
      }, 1400);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(function () {});
      return;
    }

    /* navegadores sem clipboard API */
    var tmp = document.createElement('textarea');
    tmp.value = code;
    tmp.setAttribute('readonly', '');
    tmp.style.position = 'absolute';
    tmp.style.left = '-9999px';
    document.body.appendChild(tmp);
    tmp.select();
    try {
      document.execCommand('copy');
      done();
    } catch (err) {
      /* silencioso: copiar é conveniência, não função crítica */
    }
    document.body.removeChild(tmp);
  });

  /* ------------------------------- slides adiados do destaque ------------ */

  (function () {
    var adiados = document.querySelectorAll('[data-hero-defer]');
    if (!adiados.length) return;

    var feito = false;

    function promover() {
      if (feito) return;
      feito = true;

      adiados.forEach(function (pic) {
        pic.querySelectorAll('source[data-srcset]').forEach(function (s) {
          s.setAttribute('srcset', s.getAttribute('data-srcset'));
          s.removeAttribute('data-srcset');
        });

        var img = pic.querySelector('img[data-src]');
        if (!img) return;

        var set = img.getAttribute('data-srcset');
        if (set) {
          img.setAttribute('srcset', set);
          img.removeAttribute('data-srcset');
        }
        img.setAttribute('src', img.getAttribute('data-src'));
        img.removeAttribute('data-src');
        pic.removeAttribute('data-hero-defer');
      });
    }

    /* o normal é carregar depois que a página terminou: aí não disputa
       banda com a imagem da maior pintura */
    if (document.readyState === 'complete') promover();
    else window.addEventListener('load', promover, { once: true });

    /* mas quem desliza antes disso não pode ver slide vazio */
    var trilho = document.querySelector('[data-carousel] .carousel__track');
    if (trilho) {
      ['pointerdown', 'touchstart', 'scroll', 'keydown'].forEach(function (ev) {
        trilho.addEventListener(ev, promover, { once: true, passive: true });
      });
    }

    document.querySelectorAll('.carousel__dot').forEach(function (dot) {
      dot.addEventListener('pointerdown', promover, { once: true });
    });
  })();

  /* ---------------------------------------------------------- carrossel */

  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('.carousel__track');
    var dots = carousel.querySelectorAll('.carousel__dot');
    if (!track || !dots.length) return;

    /* largura guardada: ler clientWidth a cada quadro de rolagem
       obriga o navegador a recalcular layout durante o gesto */
    var passo = track.clientWidth;

    window.addEventListener('resize', function () {
      passo = track.clientWidth;
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        track.scrollTo({ left: passo * i, behavior: 'smooth' });
      });
    });

    var pendente = false;
    track.addEventListener('scroll', function () {
      if (pendente) return;
      pendente = true;

      /* a leitura acontece uma vez por quadro, nao a cada evento */
      requestAnimationFrame(function () {
        pendente = false;
        if (!passo) passo = track.clientWidth;
        var index = Math.round(track.scrollLeft / passo);
        dots.forEach(function (dot, i) {
          dot.setAttribute('aria-selected', String(i === index));
        });
      });
    }, { passive: true });
  });

  /* --------------------------------------------------------- quantidade */

  on(document, 'click', '[data-qty]', function (e, btn) {
    e.preventDefault();
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    var step = btn.getAttribute('data-qty') === 'up' ? 1 : -1;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var next = (parseInt(input.value, 10) || min) + step;
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------- galeria do produto */

  on(document, 'click', '.product__thumb', function (e, thumb) {
    e.preventDefault();
    var gallery = thumb.closest('.product__gallery');
    var main = gallery.querySelector('.product__main-image img');
    var src = thumb.getAttribute('data-image');
    if (main && src) {
      /* leva o srcset da miniatura: sem ele a principal perderia a
         escolha por tamanho de tela e baixaria sempre a maior */
      main.srcset = thumb.getAttribute('data-image-srcset') || '';
      main.src = src;
      main.alt = thumb.getAttribute("data-image-alt") || "";
    }
    gallery.querySelectorAll('.product__thumb').forEach(function (t) {
      t.setAttribute('aria-current', String(t === thumb));
    });
  });

  /* ------------------------------------------------- variantes do produto */

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var wrapper = form.closest('[data-product]');
    if (!wrapper) return;

    var dataEl = wrapper.querySelector('[data-variants]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }

    var idInput = form.querySelector('[name="id"]');
    var submit = form.querySelector('[data-add-to-cart]');
    var priceEl = wrapper.querySelector('[data-price]');
    var stockEl = wrapper.querySelector('[data-stock]');

    function selectedOptions() {
      return Array.prototype.map.call(
        form.querySelectorAll('[data-option-index]'),
        function (group) {
          var checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        }
      );
    }

    function update() {
      var chosen = selectedOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return chosen[i] == null || opt === chosen[i];
        });
      });

      var quick = form.querySelector('.product__comprar-agora');
      var sticky = document.querySelector('[data-barra-btn]');
      if (quick) quick.hidden = !match || !match.available;
      if (idInput) idInput.disabled = !match;
      if (sticky) sticky.disabled = !match || !match.available;
      if (!match) {
        if (submit) {
          submit.disabled = true;
          submit.textContent = cfg.strings ? cfg.strings.unavailable : '';
        }
        return;
      }

      if (idInput) idInput.value = match.id;

      if (priceEl) {
        var html = '<span class="price__now">' + money(match.price) + '</span>';
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += '<span class="price__was">' + money(match.compare_at_price) + '</span>';
        }
        priceEl.innerHTML = html;
        priceEl.classList.toggle(
          'price--on-sale',
          !!(match.compare_at_price && match.compare_at_price > match.price)
        );
      }

      if (stockEl) {
        stockEl.innerHTML = match.available
          ? '<span class="dot"></span>' + stockEl.getAttribute('data-in-stock')
          : '<span class="dot dot--out"></span>' + stockEl.getAttribute('data-out-stock');
      }

      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available
          ? (cfg.strings ? cfg.strings.addToCart : '')
          : (cfg.strings ? cfg.strings.soldOut : '');
      }

      /* galeria mostra só as fotos da variante escolhida mais as
         comuns ao produto; as das outras cores ficam escondidas */
      if (match.media_id) {
        wrapper.querySelectorAll('[data-media-variante]').forEach(function (t) {
          t.hidden = t.getAttribute('data-media-variante') !== String(match.media_id);
        });
      }

      if (match.featured_image) {
        var main = wrapper.querySelector('.product__main-image img');
        var thumb = wrapper.querySelector('[data-media-variante="' + match.media_id + '"]');
        if (main) {
          main.srcset = thumb ? thumb.getAttribute('data-image-srcset') || '' : '';
          main.src = match.featured_image.src;
          main.alt = thumb ? thumb.getAttribute("data-image-alt") || "" : "";
        }
        wrapper.querySelectorAll('.product__thumb').forEach(function (t) {
          t.setAttribute('aria-current', String(t === thumb));
        });
        if (thumb && thumb.scrollIntoView) {
          thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      }

      /* nome da opção ao lado do rótulo, ex.: Cor Palha */
      chosen.forEach(function (valor, i) {
        var alvo = wrapper.querySelector('[data-option-escolhida="' + i + '"]');
        if (alvo && valor) alvo.textContent = valor;
      });

      /* selo de economia acompanha a variante */
      var selo = wrapper.querySelector('[data-economia]');
      if (selo) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          var pct = Math.floor(((match.compare_at_price - match.price) * 100) / match.compare_at_price);
          selo.textContent = selo.getAttribute('data-modelo')
            ? selo.getAttribute('data-modelo').replace('PCT', pct)
            : pct + '% OFF';
          selo.hidden = false;
        } else {
          selo.hidden = true;
        }
      }

      /* barra fixa do celular reflete preço e disponibilidade */
      var barraPreco = document.querySelector('[data-barra-preco]');
      if (barraPreco) barraPreco.textContent = money(match.price);

      var barraBtn = document.querySelector('[data-barra-btn]');
      if (barraBtn) {
        barraBtn.disabled = !match.available;
        barraBtn.textContent = match.available
          ? (cfg.strings ? cfg.strings.addToCart : '')
          : (cfg.strings ? cfg.strings.soldOut : '');
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-index] input')) update();
    });

    update();
  });

  /* ------------------------------ barra fixa de compra (celular) -------- */

  (function () {
    var barra = document.querySelector('[data-barra-compra]');
    if (!barra) return;

    var form = document.querySelector('[data-product-form]');
    var real = form && form.querySelector('[data-add-to-cart]');
    if (!real) return;

    var btn = barra.querySelector('[data-barra-btn]');

    /* o botão da barra apenas aciona o formulário real: variante,
       quantidade e o fluxo de sacola continuam sendo os mesmos */
    if (btn) {
      btn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(real);
        else real.click();
      });
    }

    function mostrar(sim) {
      if (sim) barra.hidden = false;
      barra.classList.toggle('barra-compra--visivel', sim);
      if (!sim) {
        window.setTimeout(function () {
          if (!barra.classList.contains('barra-compra--visivel')) barra.hidden = true;
        }, 260);
      }
    }

    /* IntersectionObserver em vez de escutar rolagem: o navegador avisa
       quando o botão entra ou sai da tela, sem custo a cada quadro */
    if ('IntersectionObserver' in window) {
      var observador = new IntersectionObserver(
        function (entradas) {
          entradas.forEach(function (e) {
            /* Regra única: botão à vista, barra some; botão fora da tela,
               barra aparece — não importa se ele ficou acima ou abaixo.
               Antes eu exigia que tivesse passado para cima, e a barra
               nunca surgia enquanto a pessoa ainda não tinha descido
               até ele, que é justamente a abertura da página no celular. */
            mostrar(!e.isIntersecting);
          });
        },
        { threshold: 0, rootMargin: '0px 0px -40px 0px' }
      );
      observador.observe(real);
    }
  })();

  /* ----------------------------------------------- adicionar à sacola */

  function refreshCart() {
    return fetch(cfg.routes.cart + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-cart-contents]');
        var current = document.querySelector('[data-cart-contents]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;

        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
            });
            return cart;
          });
      });
  }

  on(document, 'submit', '[data-product-form]', function (e, form) {
    if (cfg.cartType !== 'drawer') return;
    e.preventDefault();

    var submit = form.querySelector('[data-add-to-cart]');
    var original = submit ? submit.textContent : '';
    if (submit) {
      submit.disabled = true;
      submit.textContent = '…';
    }

    fetch(cfg.routes.cart_add, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message);
        return refreshCart();
      })
      .then(function () {
        openDrawer(document.getElementById('cart-drawer'));
      })
      .catch(function (err) {
        window.alert(err.message);
      })
      .finally(function () {
        if (submit) {
          submit.disabled = false;
          submit.textContent = original;
        }
      });
  });

  /* ------------------------------------------ oferta na sacola (bump) */

  on(document, 'click', '[data-bump-add]', function (e, btn) {
    e.preventDefault();
    if (btn.disabled) return;

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';

    fetch(cfg.routes.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-bump-add')), quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || original);
          return data;
        });
      })
      .then(function () {
        /* na página da sacola recarrega, para os totais baterem */
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return;
        }
        return refreshCart();
      })
      .catch(function (err) {
        window.alert(err.message);
        btn.disabled = false;
        btn.textContent = original;
      });
  });

  /* --------------------------------------------- alterar itens da sacola */

  function changeLine(key, quantity) {
    return fetch(cfg.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return;
        }
        return refreshCart();
      });
  }

  on(document, 'click', '[data-cart-remove]', function (e, btn) {
    e.preventDefault();
    changeLine(btn.getAttribute('data-cart-remove'), 0);
  });

  on(document, 'change', '[data-cart-qty]', function (e, input) {
    changeLine(input.getAttribute('data-cart-qty'), parseInt(input.value, 10) || 0);
  });

  /* ------------------------------------------------------------- chat */

  (function () {
    var chat = document.querySelector('[data-chat]');
    if (!chat) return;

    var painel = chat.querySelector('.chat__painel');
    var abrir = chat.querySelector('[data-chat-open]');
    var corpo = chat.querySelector('[data-chat-corpo]');
    var form = chat.querySelector('[data-chat-form]');
    var endpoint = chat.getAttribute('data-chat-endpoint');

    /* id de sessao apenas para agrupar a conversa; sem dado pessoal */
    var sessao;
    try {
      sessao = sessionStorage.getItem('veluna-chat');
      if (!sessao) {
        sessao = String(Date.now()) + Math.random().toString(36).slice(2, 8);
        sessionStorage.setItem('veluna-chat', sessao);
      }
    } catch (err) {
      sessao = 'anonimo';
    }

    function alternar(mostrar) {
      painel.hidden = !mostrar;
      chat.classList.toggle('chat--aberto', mostrar);
      abrir.setAttribute('aria-expanded', String(mostrar));
      if (mostrar) {
        var campo = chat.querySelector('#chat-input');
        if (campo) campo.focus();
      }
    }

    /* ---------------- arrastar o botao pela tela ----------------
       O cliente escolhe onde o botao fica, para ele nao cobrir preco,
       foto ou botao de compra. A escolha vale para as proximas visitas. */

    var POS = 'veluna-chat-pos';
    var MARGEM = 12;
    var LIMIAR = 6; /* abaixo disso foi toque, nao arraste */

    function guardar(x, y) {
      try {
        localStorage.setItem(POS, JSON.stringify({ x: x, y: y }));
      } catch (err) {
        /* navegacao privada: a posicao vale so nesta sessao */
      }
    }

    /* Medidas guardadas: ler offsetWidth logo depois de escrever estilo
       obriga o navegador a recalcular o layout no meio do arraste. Medimos
       uma vez por gesto e reaproveitamos. */
    var medida = { largura: 0, altura: 0, telaX: 0, telaY: 0 };

    function medir() {
      var r = chat.getBoundingClientRect();
      medida.largura = r.width;
      medida.altura = r.height;
      medida.telaX = window.innerWidth;
      medida.telaY = window.innerHeight;
      return r;
    }

    function aplicar(x, y) {
      var largura = medida.largura || chat.offsetWidth;
      var altura = medida.altura || chat.offsetHeight;
      var telaX = medida.telaX || window.innerWidth;
      var telaY = medida.telaY || window.innerHeight;

      /* mantem o botao inteiro dentro da tela, mesmo apos girar o aparelho */
      var maxX = telaX - largura - MARGEM;
      var maxY = telaY - altura - MARGEM;
      x = Math.max(MARGEM, Math.min(x, Math.max(MARGEM, maxX)));
      y = Math.max(MARGEM, Math.min(y, Math.max(MARGEM, maxY)));

      chat.classList.add('chat--movido');
      chat.style.setProperty('--chat-x', x + 'px');
      chat.style.setProperty('--chat-y', y + 'px');

      /* painel abre para o lado e o sentido que couberem */
      chat.classList.toggle('chat--esquerda', x + largura / 2 < telaX / 2);
      chat.classList.toggle('chat--topo', y + altura / 2 < telaY / 2);

      ultimo.x = x;
      ultimo.y = y;
      return ultimo;
    }

    /* posicao salva de visitas anteriores */
    try {
      var salvo = JSON.parse(localStorage.getItem(POS) || 'null');
      if (salvo && typeof salvo.x === 'number' && typeof salvo.y === 'number') {
        medir();
        aplicar(salvo.x, salvo.y);
      }
    } catch (err) {
      /* sem posicao salva: fica no canto padrao */
    }

    var ultimo = { x: 0, y: 0 };
    var arrastando = false;
    var moveu = false;
    var inicioX = 0;
    var inicioY = 0;
    var baseX = 0;
    var baseY = 0;

    abrir.addEventListener('pointerdown', function (e) {
      if (e.button != null && e.button !== 0) return;
      var r = medir();
      arrastando = true;
      moveu = false;
      inicioX = e.clientX;
      inicioY = e.clientY;
      baseX = r.left;
      baseY = r.top;
      abrir.setPointerCapture(e.pointerId);
    });

    abrir.addEventListener('pointermove', function (e) {
      if (!arrastando) return;
      var dx = e.clientX - inicioX;
      var dy = e.clientY - inicioY;

      if (!moveu && Math.abs(dx) + Math.abs(dy) < LIMIAR) return;

      moveu = true;
      chat.classList.add('chat--arrastando');
      aplicar(baseX + dx, baseY + dy);
    });

    function encerrar(e) {
      if (!arrastando) return;
      arrastando = false;
      chat.classList.remove('chat--arrastando');

      if (moveu) {
        guardar(ultimo.x, ultimo.y);
      }

      try {
        abrir.releasePointerCapture(e.pointerId);
      } catch (err) {
        /* ponteiro ja liberado */
      }
    }

    abrir.addEventListener('pointerup', encerrar);
    abrir.addEventListener('pointercancel', encerrar);

    /* teclado: setas movem o botao com o foco nele */
    abrir.addEventListener('keydown', function (e) {
      var passo = e.shiftKey ? 40 : 10;
      var eixo = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] }[e.key];
      if (!eixo) return;
      e.preventDefault();
      var r = medir();
      var fim = aplicar(r.left + eixo[0] * passo, r.top + eixo[1] * passo);
      guardar(fim.x, fim.y);
    });

    /* girar o aparelho ou redimensionar nao pode deixar o botao fora da tela */
    window.addEventListener('resize', function () {
      if (!chat.classList.contains('chat--movido')) return;
      var r = medir();
      aplicar(r.left, r.top);
    });

    abrir.addEventListener('click', function (e) {
      /* o arraste termina num clique: esse nao pode abrir o painel */
      if (moveu) {
        moveu = false;
        e.preventDefault();
        return;
      }
      alternar(painel.hidden);
    });

    on(chat, 'click', '[data-chat-close]', function () {
      alternar(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !painel.hidden) alternar(false);
    });

    function adicionar(texto, tipo) {
      var el = document.createElement('div');
      el.className = 'chat__msg chat__msg--' + tipo;
      el.textContent = texto;
      corpo.appendChild(el);
      corpo.scrollTop = corpo.scrollHeight;
      return el;
    }

    if (!form || !endpoint) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var campo = form.querySelector('input');
      var texto = campo.value.trim();
      if (!texto) return;

      adicionar(texto, 'cliente');
      campo.value = '';

      var esperando = adicionar('…', 'loja');

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: texto, session: sessao, page: window.location.href })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('falha');
          return r.json();
        })
        .then(function (data) {
          esperando.textContent = data.reply || '';
        })
        .catch(function () {
          /* falha de rede nao pode virar silencio: o cliente precisa de saida */
          esperando.textContent = chat.getAttribute('data-erro') || 'Não consegui responder agora. Use o WhatsApp ou o formulário de contato.';
        });
    });
  })();

  /* ---------------------------------------- painel de filtros no celular */

  on(document, 'click', '[data-facets-toggle]', function (e, btn) {
    e.preventDefault();
    var painel = document.getElementById('facets');
    if (!painel) return;
    var aberto = painel.classList.toggle('facets--open');
    btn.setAttribute('aria-expanded', String(aberto));
  });

  /* ------------------------------------------------ ordenar e filtrar */

  on(document, 'change', '[data-auto-submit]', function (e, el) {
    var form = el.closest('form');
    if (form) form.submit();
  });
})();
